import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  SubclassFeature 
} from "@dndModels";

import StringBox from "@components/input/strings/StringBox";

import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  obj: SubclassFeature;
  disabled: boolean;
  onChange: (changed: SubclassFeature) => void;
}

export default function SubclassFeatureInput({ 
  obj,
  disabled,
  onChange }: Props) {
  const [ff, setFF] = useState(obj.clone());
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  return (
    <Grid container spacing={0} direction="column">
      <Grid>
        <StringBox
          name="Subclass Feature Level"
          value={ff.level}
          type="number"
          disabled={disabled}
          onBlur={(changed: string) => {
            const new_obj = ff;
            new_obj.level = +changed;
            setFF(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      { ff.level === 1 &&
        <>
          <Grid>
            <StringBox 
              name="Subclasses Called"
              value={ff.subclasses_called}
              disabled={disabled}
              onBlur={(changed: string) => {
                const new_obj = ff;
                new_obj.subclasses_called = changed;
                setFF(new_obj);
                onChange(new_obj);
              }}
            />
          </Grid>
          <Grid>
            <SelectObjectBox 
              name="For Class" 
              data_type="game_class"
              value={ff.for_class_id} 
              extra_options={["None"]}
              disabled={disabled}
              onChange={(changed: string) => {
                const new_obj = ff;
                if (changed === "None") {
                  new_obj.for_class_id = "";
                  new_obj.suggested = "";
                } else {
                  new_obj.for_class_id = changed;
                }
                setFF(new_obj);
                onChange(new_obj);
                setReloading(true);
              }} 
            />
          </Grid>
          <Grid>
            { !reloading && 
              <SelectObjectBox
                name="Suggested Subclass" 
                data_type="subclass"
                display_format="{obj.true_name}"
                filter={{ game_class_id: ff.for_class_id }} 
                value={ff.suggested} 
                extra_options={["None"]}
                // log_it
                onChange={(changed: string) => {
                  const new_obj = ff;
                  new_obj.suggested = changed;
                  setFF(new_obj);
                  onChange(new_obj);
                }}
              />
            }
          </Grid>
        </>
      }
    </Grid>
  );
}
